import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import { getSections } from '../../services/api';
import './admin.css';

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await getSections(true);
      setData(response);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const stats = data ? [
    { label: 'Sections', value: data.sections?.length || 0, icon: '📚', link: '/admin/sections' },
    { label: 'Avis', value: data.testimonials?.length || 0, icon: '💬', link: '/admin/testimonials' },
    { label: 'Prix', value: data.pricingItems?.length || 0, icon: '💰', link: '/admin/pricing' },
  ] : [];

  return (
    <AdminLayout>
      <div className="admin-dashboard">
        <header className="admin-page-header">
          <h1>Tableau de bord</h1>
          <p>Bienvenue dans le panneau d'administration</p>
        </header>

        {loading ? (
          <div className="admin-loading">
            <div className="spinner"></div>
            <p>Chargement...</p>
          </div>
        ) : error ? (
          <div className="admin-alert admin-alert-error">{error}</div>
        ) : (
          <>
            <div className="admin-stats-grid">
              {stats.map((stat) => (
                <Link to={stat.link} key={stat.label} className="admin-stat-card">
                  <span className="admin-stat-icon">{stat.icon}</span>
                  <div className="admin-stat-info">
                    <span className="admin-stat-value">{stat.value}</span>
                    <span className="admin-stat-label">{stat.label}</span>
                  </div>
                </Link>
              ))}
            </div>

            <section className="admin-section">
              <h2>Sections du site</h2>
              <div className="admin-table-container">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th>Ordre</th>
                      <th>Nom</th>
                      <th>Type</th>
                      <th>Statut</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.sections?.map((section) => (
                      <tr key={section.id}>
                        <td>{section.order}</td>
                        <td>{section.name}</td>
                        <td>
                          <span className="admin-badge">{section.type}</span>
                        </td>
                        <td>
                          <span className={`admin-status ${section.isActive ? 'active' : 'inactive'}`}>
                            {section.isActive ? 'Actif' : 'Inactif'}
                          </span>
                        </td>
                        <td>
                          <Link to={`/admin/sections/${section.id}`} className="admin-btn admin-btn-sm">
                            Modifier
                          </Link>
                        </td>
                      </tr>
                    ))}
                    {(!data?.sections || data.sections.length === 0) && (
                      <tr>
                        <td colSpan="5" className="admin-table-empty">
                          Aucune section. <Link to="/admin/sections/new">Créer une section</Link>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </section>
          </>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;

